<mat-card class="company-form">
  <app-company-list></app-company-list>
</mat-card>